import { render, staticRenderFns } from "./SmsNotificationsUnavailableBanner.vue?vue&type=template&id=3887d9f9&scoped=true&"
import script from "./SmsNotificationsUnavailableBanner.vue?vue&type=script&lang=js&"
export * from "./SmsNotificationsUnavailableBanner.vue?vue&type=script&lang=js&"
import style0 from "./SmsNotificationsUnavailableBanner.vue?vue&type=style&index=0&id=3887d9f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3887d9f9",
  null
  
)

export default component.exports